import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getNotes as onGetNotes,
    addNewNote as onAddNewNote,
    updateNote as onUpdateNote,
    deleteNote as onDeleteNote,

    getEvaluations as onGetEvaluations,
    getStudents as onGetStudents,
    getCourseComponents as onGetCourseComponents,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Note = () => {

    //meta title
    document.title = "Notes | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [note, setNote] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (note && note.uid) || '',
            student_id: (note && note.student_id) || '',
            evaluation_id: (note && note.evaluation_id) || '',
            subject_id: (note && note.subject_id) || '',
            note: (note && note.note) || '',
            
        },
        validationSchema: Yup.object({
           
            student_id: Yup.number().required("Veuillez sélectionner l'étudiant"),
            evaluation_id: Yup.number().required("Veuillez sélectionner l'évaluation'"),
            subject_id: Yup.number().required("Veuillez saisir le cours"),
            amount: Yup.number().required("Veuillez saisir la note"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const note = {
                    //id: values.id,
                    uid: values.uid,
                    student_id: values.student_id,
                    evaluation_id: values.evaluation_id,
                    subject_id: values.subject_id,
                    note: values.note,
                    
                };
                // update movie category
                dispatch(onUpdateNote(note));
                validation.resetForm();
            } else {
                const newNote = {
                    //id: values["id"],
                    //uid: values["uid"],
                   
                    student_id: values["student_id"],
                    evaluation_id: values["evaluation_id"],
                    subject_id: values["subject_id"],
                    note: values["note"],
                   
                };
                // save new movie category
                dispatch(onAddNewNote(newNote));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const NoteProperties = createSelector(
        (state) => state.noteReducer, 
        (noteReducer) => ({
            notes: noteReducer.notes,
            loading: noteReducer.loading
        })
    );

    const {notes, loading} = useSelector(NoteProperties);

    const [isLoading, setLoading] = useState(loading)


     // Evaluations
    const EvaluationProperties = createSelector(
        (state) => state.evaluationReducer, 
        (evaluationReducer) => ({
            evaluations: evaluationReducer.evaluations,
            loading: evaluationReducer.loading
        })
    );

    const {evaluations} = useSelector(EvaluationProperties);


     // Students
    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students} = useSelector(StudentProperties);


    // CourseComponents
    const CourseComponentProperties = createSelector(
        (state) => state.courseComponentReducer, 
        (courseComponentReducer) => ({
            courseComponents: courseComponentReducer.courseComponents,
            loading: courseComponentReducer.loading
        })
    );

    const {courseComponents} = useSelector(CourseComponentProperties);
    

    

    useEffect(() => {
        if (notes && !notes.length) {
            dispatch(onGetNotes());
        }

        if (evaluations && !evaluations.length) {
            dispatch(onGetEvaluations());
        }

        if (students && !students.length) {
            dispatch(onGetStudents());
        }

         if (courseComponents && !courseComponents.length) {
            dispatch(onGetCourseComponents());
        }
    }, [dispatch, notes.length, evaluations.length, students.length, courseComponents.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setNote(null);
        } else {
            setModal(true);
        }
    };

    const handleNoteClick = arg => {
        const note = arg;
        setNote({
            id: note.id,
            uid: note.uid,
            student_id: note.student_id,
            evaluation_id: note.evaluation_id,
            subject_id: note.subject_id,
            note: note.note,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (note) => {
        setNote(note);
        setDeleteModal(true);
    };

    const handleDeleteNote = () => {
        if (note && note.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteNote(note));
            setDeleteModal(false);
        }
    };

    const onClickNewNote = () => {
        setIsEdit(false);
        setNote(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Étudiant",
                accessorKey: "student.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Évaluation",
                accessorKey: "evaluation.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Cours",
                accessorKey: "course.id",
                enableColumnFilter: false,
                enableSorting: true,
            },

             {
                header: "Note",
                accessorKey: "note",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleNoteClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteNote}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Notes" breadcrumbItem="Liste des notes" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewNote} className="btn btn-primary me-1">Ajouter une note</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={notes || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Note" : "Ajouter - Note"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                       

                                       

                                        <div className="mb-3">
                                            <Label>Évaluation</Label>
                                            <Input
                                                name="evaluation_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.evaluation_id || ""
                                                }
                                                invalid={
                                                    validation.touched.evaluation_id && validation.errors.evaluation_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {evaluations.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.title}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.evaluation_id && validation.errors.evaluation_id ? (
                                                <FormFeedback type="invalid">{validation.errors.evaluation_id}</FormFeedback>
                                            ) : null}
                                        </div>


                                        <div className="mb-3">
                                            <Label>Étudiant</Label>
                                            <Input
                                                name="student_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.student_id || ""
                                                }
                                                invalid={
                                                    validation.touched.student_id && validation.errors.student_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {students.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.student_id && validation.errors.student_id ? (
                                                <FormFeedback type="invalid">{validation.errors.student_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Matière</Label>
                                            <Input
                                                name="course_component_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.subject_id || ""
                                                }
                                                invalid={
                                                    validation.touched.subject_id && validation.errors.subject_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {courseComponents.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.subject_id && validation.errors.subject_id ? (
                                                <FormFeedback type="invalid">{validation.errors.subject_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Note</Label>
                                            <Input
                                                name="note"
                                                type="numeric"
                                                placeholder="Note"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.note || ""}
                                                invalid={
                                                    validation.touched.note && validation.errors.note ? true : false
                                                }
                                            />
                                            {validation.touched.note && validation.errors.note ? (
                                                <FormFeedback type="invalid">{validation.errors.note}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Note;